"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GsnRecipientSignatureFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var GsnRecipientSignatureFactory = /** @class */ (function (_super) {
    __extends(GsnRecipientSignatureFactory, _super);
    function GsnRecipientSignatureFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    GsnRecipientSignatureFactory.prototype.deploy = function (trustedSigner, overrides) {
        return _super.prototype.deploy.call(this, trustedSigner, overrides || {});
    };
    GsnRecipientSignatureFactory.prototype.getDeployTransaction = function (trustedSigner, overrides) {
        return _super.prototype.getDeployTransaction.call(this, trustedSigner, overrides || {});
    };
    GsnRecipientSignatureFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    GsnRecipientSignatureFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    GsnRecipientSignatureFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return GsnRecipientSignatureFactory;
}(contracts_1.ContractFactory));
exports.GsnRecipientSignatureFactory = GsnRecipientSignatureFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'address',
                name: 'trustedSigner',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'oldRelayHub',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newRelayHub',
                type: 'address',
            },
        ],
        name: 'RelayHubChanged',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'relay',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'bytes',
                name: 'encodedFunction',
                type: 'bytes',
            },
            {
                internalType: 'uint256',
                name: 'transactionFee',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'gasPrice',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'gasLimit',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'nonce',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'approvalData',
                type: 'bytes',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'acceptRelayedCall',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getHubAddr',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes',
                name: 'context',
                type: 'bytes',
            },
            {
                internalType: 'bool',
                name: 'success',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: 'actualCharge',
                type: 'uint256',
            },
            {
                internalType: 'bytes32',
                name: 'preRetVal',
                type: 'bytes32',
            },
        ],
        name: 'postRelayedCall',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes',
                name: 'context',
                type: 'bytes',
            },
        ],
        name: 'preRelayedCall',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'relayHubVersion',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=GsnRecipientSignatureFactory.js.map